import { useState, useEffect } from 'react';
import api from '../../../services/api';
import { API_ENDPOINTS } from '../../../utils/constants';

// Loads the option/token lists the Trade Recommendation form needs on mount.
// Fetchers moved verbatim from TradeRecommendationForm.jsx — behaviour unchanged.
const useTradeFormOptions = () => {
  const [tradeTypeIdOptions, setTradeTypeIdOptions] = useState([]);  // "Type" dropdown
  const [scriptTypeOptions, setScriptTypeOptions] = useState([]);    // "Script Type" dropdown
  const [internalTokens, setInternalTokens] = useState([]);          // searchable stock list

  // Load trade types and reshape them into { value, label } for the dropdown.
  const fetchTradeTypes = async () => {
    try {
      const res = await api.get(`${API_ENDPOINTS.TRADE_TYPE}`);
      const formattedOptions = res.data.map(item => ({
        value: String(item.tradeTypeId),
        label: item.tradeTypeName
      }));

      setTradeTypeIdOptions(formattedOptions);
    } catch (error) {
      console.log("Error fetching trade type id", error);
    }
  };

  // Load the list of tradeable stocks used by the Script search box.
  const fetchScript = async () => {
    try {
      // Using internaltoken/list to match CommunityMaster behavior
      const res = await api.get('/internaltoken/searchTradeRecommendation');
      if(res.status && res.data) {
        console.log('Fetched tokens:', res.data);
      }
      if (res.status && res.data) {
        setInternalTokens(res.data);
        // We don't need scriptIdOptions anymore for this field, but keeping logic clean
      }
    } catch (error) {
      console.log("Error fetching tokens", error);
    }
  };

  // Load script types (Equity / Futures / Options) for the dropdown.
  const fetchScriptType = async () => {
    try {
      const res = await api.get(`${API_ENDPOINTS.SCRIPT_TYPE}`);
      const formattedOptions = res.data.map((item) => ({
        id: item.scriptTypeId,
        value: item.scriptTypeId,
        label: item.scriptTypeName,
      }));

      setScriptTypeOptions(formattedOptions);
    } catch (error) {
      console.log("Error fetching script type", error);
    }
  };

  // Run all three loaders once, when the form first opens.
  useEffect(() => {
    fetchScript();
    fetchTradeTypes();
    fetchScriptType();
  }, []);

  // Hand the finished lists back to the component (setters stay private).
  return { tradeTypeIdOptions, scriptTypeOptions, internalTokens };
};

export default useTradeFormOptions;
